// Copyright 2020
//   __  __                       _           _     _   _            _ _   _
//  |  \/  | ___   ___  _ __  ___| |__   ___ | |_  | | | | ___  __ _| | |_| |__
//  | |\/| |/ _ \ / _ \| '_ \/ __| '_ \ / _ \| __| | |_| |/ _ \/ _` | | __| '_ \
//  | |  | | (_) | (_) | | | \__ \ | | | (_) | |_  |  _  |  __/ (_| | | |_| | | |
//  |_|  |_|\___/ \___/|_| |_|___/_| |_|\___/ \__| |_| |_|\___|\__,_|_|\__|_| |_|
//
//  All Rights Reserved.
//
// NOTICE:  All information contained herein is, and remains
// the property of Moonshot Health Incorporated and its suppliers,
// if any.  The intellectual and technical concepts contained
// herein are proprietary to Adobe Systems Incorporated
// and its suppliers and may be covered by U.S. and Foreign Patents,
// patents in process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Moonshot Health Incorporated.

// @generated by protoc-gen-es v1.3.3 with parameter "target=js,import_extension=none"
// @generated from file msh/resource/v1/structure.proto (package msh.resource.v1, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3, Timestamp } from "@bufbuild/protobuf";
import { Agent } from "../../common/v1/common_pb";
import { Device } from "./device_pb";
import { Alert } from "./alert_pb";
import { Language } from "../../common/v1/language_pb";
import { User } from "./user_pb";
import { WanderingSettings } from "./wandering_pb";
import { AddressFormat } from "../../common/v1/address_pb";
import { AlertContact } from "./alert_contact_pb";

/**
 * @generated from message msh.resource.v1.Structure
 */
export const Structure = proto3.makeMessageType(
  "msh.resource.v1.Structure",
  () => [
    { no: 1, name: "consumer", kind: "message", T: Structure_Consumer, oneof: "type" },
    { no: 2, name: "business", kind: "message", T: Structure_Business, oneof: "type" },
  ],
);

/**
 * @generated from message msh.resource.v1.Structure.Business
 */
export const Structure_Business = proto3.makeMessageType(
  "msh.resource.v1.Structure.Business",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 5, name: "created_by", kind: "message", T: Agent },
    { no: 6, name: "creation_time", kind: "message", T: Timestamp },
    { no: 7, name: "rooms", kind: "message", T: Room, repeated: true },
    { no: 8, name: "devices", kind: "message", T: Device, repeated: true },
    { no: 9, name: "alerts", kind: "message", T: Alert, repeated: true },
    { no: 10, name: "stats", kind: "message", T: StructureBusinessStatistics },
    { no: 11, name: "presence_status", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 12, name: "last_presence_updated", kind: "message", T: Timestamp },
    { no: 13, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 14, name: "resident", kind: "message", T: User },
    { no: 15, name: "users", kind: "message", T: User, repeated: true },
  ],
  {localName: "Structure_Business"},
);

/**
 * @generated from message msh.resource.v1.Structure.Consumer
 */
export const Structure_Consumer = proto3.makeMessageType(
  "msh.resource.v1.Structure.Consumer",
  () => [
    { no: 1, name: "structure_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "owner", kind: "message", T: User },
    { no: 4, name: "users", kind: "message", T: User, repeated: true },
    { no: 5, name: "created_by", kind: "message", T: Agent },
    { no: 6, name: "creation_time", kind: "message", T: Timestamp },
    { no: 7, name: "rooms", kind: "message", T: Room, repeated: true },
    { no: 8, name: "devices", kind: "message", T: Device, repeated: true },
    { no: 9, name: "alerts", kind: "message", T: Alert, repeated: true },
    { no: 10, name: "stats", kind: "message", T: StructureConsumerStatistics },
    { no: 11, name: "presence_status", kind: "scalar", T: 13 /* ScalarType.UINT32 */ },
    { no: 12, name: "last_presence_updated", kind: "message", T: Timestamp },
    { no: 13, name: "lang", kind: "enum", T: proto3.getEnumType(Language) },
    { no: 14, name: "wandering_settings", kind: "message", T: WanderingSettings },
    { no: 15, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
  {localName: "Structure_Consumer"},
);

/**
 * @generated from message msh.resource.v1.Building
 */
export const Building = proto3.makeMessageType(
  "msh.resource.v1.Building",
  () => [
    { no: 1, name: "building_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "managers", kind: "message", T: User, repeated: true },
    { no: 4, name: "users", kind: "message", T: User, repeated: true },
    { no: 5, name: "address", kind: "message", T: AddressFormat },
    { no: 6, name: "creation_time", kind: "message", T: Timestamp },
    { no: 7, name: "created_by", kind: "message", T: Agent },
    { no: 8, name: "floors", kind: "message", T: Floor, repeated: true },
    { no: 9, name: "contacts", kind: "message", T: AlertContact, repeated: true },
    { no: 10, name: "stats", kind: "message", T: Statistics },
    { no: 11, name: "wandering_settings", kind: "message", T: WanderingSettings },
    { no: 12, name: "timezone", kind: "scalar", T: 9 /* ScalarType.STRING */ },
  ],
);

/**
 * @generated from message msh.resource.v1.Floor
 */
export const Floor = proto3.makeMessageType(
  "msh.resource.v1.Floor",
  () => [
    { no: 1, name: "floor_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "structures", kind: "message", T: Structure, repeated: true },
    { no: 4, name: "creation_time", kind: "message", T: Timestamp },
    { no: 5, name: "created_by", kind: "message", T: Agent },
    { no: 6, name: "stats", kind: "message", T: Statistics },
  ],
);

/**
 * @generated from message msh.resource.v1.Room
 */
export const Room = proto3.makeMessageType(
  "msh.resource.v1.Room",
  () => [
    { no: 1, name: "room_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "label", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 3, name: "creation_time", kind: "message", T: Timestamp },
    { no: 5, name: "created_by", kind: "message", T: Agent },
  ],
);

/**
 * Represent statistics related to alerts, presences and structures for a building, floor or structure
 *
 * @generated from message msh.resource.v1.Statistics
 */
export const Statistics = proto3.makeMessageType(
  "msh.resource.v1.Statistics",
  () => [
    { no: 1, name: "stats_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_alerts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "total_presents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 4, name: "total_structures", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 5, name: "total_absents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 6, name: "total_unknowns", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 7, name: "total_onlines", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 8, name: "total_offlines", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message msh.resource.v1.StructureConsumerStatistics
 */
export const StructureConsumerStatistics = proto3.makeMessageType(
  "msh.resource.v1.StructureConsumerStatistics",
  () => [
    { no: 1, name: "stats_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_alerts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

/**
 * @generated from message msh.resource.v1.StructureBusinessStatistics
 */
export const StructureBusinessStatistics = proto3.makeMessageType(
  "msh.resource.v1.StructureBusinessStatistics",
  () => [
    { no: 1, name: "stats_id", kind: "scalar", T: 9 /* ScalarType.STRING */ },
    { no: 2, name: "total_alerts", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
    { no: 3, name: "total_presents", kind: "scalar", T: 5 /* ScalarType.INT32 */ },
  ],
);

